import { useQuery } from "@apollo/client";
import { CardContent } from "@material-ui/core";
import React, { FC } from "react";
import RefPeriodChart from "../BuildingInsights/ReferencePeriodChart";
import DashboardCard from "../ui/DashboardCard";
import Loading from "../ui/Loading";
import { ReferencePeriodChartQueryDocument } from "./ReferencePeriodChartQuery.generated";

interface Props {
  calibratedModelId: string;
}

const ReferencePeriodChart: FC<Props> = ({ calibratedModelId }) => {
  const { data, loading, error } = useQuery(ReferencePeriodChartQueryDocument, {
    variables: { id: calibratedModelId },
  });

  if (error) throw error;

  // TODO: Skeletonize!
  if (loading || !data) return <Loading variant="circle" />;

  const ASPECT = 20 / 9;
  const { calibratedModel: model } = data;

  return (
    <DashboardCard label="Reference period">
      <CardContent>
        <RefPeriodChart aspect={ASPECT} data={model.reference} />
      </CardContent>
    </DashboardCard>
  );
};

export default ReferencePeriodChart;
